const preloadedCardUrls = new Set<string>();

export function cardImageUrl(cardId: string) {
  const [set, id] = cardId.split(":");
  if (!set || !id) {
    return "";
  }

  return `/art/cards/${set}/${id}.png`;
}

export function preloadCardImages(cardIds: readonly string[]) {
  for (const cardId of cardIds) {
    preloadCardImage(cardId);
  }
}

function preloadCardImage(cardId: string) {
  const src = cardImageUrl(cardId);
  if (!src || preloadedCardUrls.has(src)) {
    return;
  }

  preloadedCardUrls.add(src);

  const image = new Image();
  image.src = src;
}
